import { BaseMutations } from '@/store/base-mutations';
import { Subpartners, SubpartnerFileUploadData } from '../../../types';
import SubpartnersSalesState from './state';

export default class SubpartnersSalesMutations extends BaseMutations<SubpartnersSalesState> {
  SET_SUBPARTNERS_SALES(sales: Subpartners.SubpartnerSales[]) {
    this.state.subpartners_sales = sales;
  }

  SET_DOC_TEMPLATE_LINK(path: string) {
    this.state.doc_template_link = path;
  }

  SET_FILE_UPLOAD_DETAILS(data: SubpartnerFileUploadData) {
    this.state.file_upload_details = data;
  }

  TOGGLE_SALES_LOADING(value: boolean) {
    this.state.sales_loading = value;
  }
}
